import type { FC } from 'react';
import TicketIcon from '@material-ui/icons/AirplanemodeActiveOutlined';
import TrashIcon from '@material-ui/icons/DeleteOutlined';
import pluralize from 'pluralize';
import { IconButton } from '@material-ui/core';
import { TicketInput } from '../../Forms/TicketForm/types';
import { formatMonthDayYear } from '../../../../utils/utils';

interface Props {
  ticket: TicketInput;
  onDelete?: (id: string) => void;
  onEdit?: () => void;
}

const TicketSummaryItem: FC<Props> = ({ ticket, onDelete, onEdit }) => {
  const handleDelete = () => {
    if (ticket.id) {
      onDelete?.(ticket.id);
    }
  };
  return (
    <div onClick={onEdit} className="flex items-top justify-between px-3 py-2 hover:bg-gray-50 hover:cursor-pointer">
      <div className="flex items-top">
        <TicketIcon className="text-blue-800 mr-4 mt-1" />
        <div>
          <div className="font-bold">{ticket.company}</div>
          <div className="text-xs text-grey-500 space-x-1">
            <span>Departure: {formatMonthDayYear(+ticket.departure.date)}</span>
            {ticket.departure.reference ? (
              <>
                <span className="text-xs text-grey-500">|</span>
                <span className="text-xs text-grey-500">{ticket.departure.reference}</span>
              </>
            ) : null}
          </div>
          {ticket.return ? (
            <div className="text-xs text-grey-500 space-x-1">
              <span>Return: {formatMonthDayYear(+ticket.return.date)}</span>
              {ticket.return.reference ? (
                <>
                  <span className="text-xs text-grey-500">|</span>
                  <span className="text-xs text-grey-500">{ticket.return.reference}</span>
                </>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
      <div>
        {onDelete && (
          <IconButton
            aria-label="delete"
            className=" mt-1"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
          >
            <TrashIcon className="text-red-500" />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default TicketSummaryItem;
